import { render, staticRenderFns } from "./DeclarationsModal.vue?vue&type=template&id=0e240c06&scoped=true&"
import script from "./DeclarationsModal.vue?vue&type=script&lang=js&"
export * from "./DeclarationsModal.vue?vue&type=script&lang=js&"
import style0 from "./DeclarationsModal.vue?vue&type=style&index=0&id=0e240c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e240c06",
  null
  
)

export default component.exports